import "./forms.css";
import React from "react";
import { PulseLoader } from "react-spinners";
import { Field, reduxForm } from "redux-form";
import { renderField } from "./_fieldRenderer";
import { FormGroup, Row, Col } from "react-bootstrap";
import Button from "../elements/CustomButton/CustomButton.jsx";

class LoginForm extends React.Component {
  render() {
    const { handleSubmit, submitting, loading } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="email"
                type="email"
                component={renderField}
                label="Email"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="password"
                type="password"
                component={renderField}
                label="Senha"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="form__actions_margin">
          <Button
            style={{ marginRight: 15 }}
            className="pull-right"
            bsStyle="default"
            type="submit"
            disabled={submitting || loading}
            wd
          >
            {loading ? <PulseLoader color={"#6C1137"} size={7} /> : "Entrar"}
          </Button>
        </Row>
      </form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = "Obrigatório";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Formato inválido";
  }

  if (!values.password) {
    errors.email = "Obrigatório";
  } else if (values.password.length < 8) {
    errors.password = "Min. 8 caracteres";
  }
  return errors;
};

LoginForm = reduxForm({ form: "LoginForm", validate })(LoginForm);
export default LoginForm;



// WEBPACK FOOTER //
// ./src/forms/LoginForm.jsx